import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Switch,
  Typography,
} from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { TextBlockInfoCompact } from "components/ReportNodeTextBlock/TextBlockInfoCompact"
import { DataNode } from "graphql/types"
import { useState } from "react"
import { isNodeTable } from "store/typeGuards"
import EditableTable from "./EditableTable"
import { ReportNodeTableBoxWithDiff } from "./ReportNodeTableBoxWithDiff"

type ReportNodeTableEditDialogProps = {
  open: boolean
  onClose: () => void
  node: DataNode
  setNode: (node: DataNode) => void
  onSave: () => void
}

export const ReportNodeTableEditDialog = (props: ReportNodeTableEditDialogProps) => {
  const { open, onClose, node, setNode, onSave } = props

  const [editMode, setEditMode] = useState(false)

  return (
    <Dialog maxWidth="lg" fullWidth open={open}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h6">Tabelle bearbeiten</Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2">Bearbeitungsmodus:</Typography>
            <Switch
              checked={editMode}
              onChange={(e) => setEditMode(e.target.checked)}
              size="small"
            />
            <Typography variant="body2">{editMode ? "Ein" : "Aus"}</Typography>
          </Box>
        </Box>
        <TextBlockInfoCompact dataNode={node} />
      </DialogTitle>

      <DialogContent>
        {node && isNodeTable(node) && (
          <EditableTable table={node} setTable={setNode} editMode={editMode} />
        )}

        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Vorschau
          </Typography>

          {isNodeTable(node) && <ReportNodeTableBoxWithDiff data={node} />}
        </Paper>
      </DialogContent>
      <DialogActions>
        <StyledButton buttonType="cancel" onClick={onClose} />
        <StyledButton buttonType="save" onClick={onSave} />
      </DialogActions>
    </Dialog>
  )
}
